import { ITlfActionSetViewMode, TlfContextProps } from "./interface";

/**
 * Replaces the active TLF view-mode configuration.
 *
 * @param state - Current TLF context state.
 * @param action - Set-view-mode action containing the next mode.
 * @returns Updated state with the active view mode changed.
 */
export const tlf_setViewMode = (
  state: TlfContextProps,
  action: ITlfActionSetViewMode,
): TlfContextProps => ({
  ...state,
  tlfViewMode: action.tlfViewMode,
});
